// extracted by mini-css-extract-plugin
export default {"toggle":"tabview_toggle__EJE-p","slider":"tabview_slider__6q9vD","toggleContainer":"tabview_toggleContainer__aNMX4"};